// @flow

export default (t: (id: string, obj?: Object) => string) => ({
  id: {
    "ui:widget": "hidden",
  },
  "ui:order": ["country", "region", "sector", "industry", "*"],
  address: {
    "ui:order": [
      "addressLine1",
      "addressLine2",
      "addressLine3",
      "city",
      "postCode",
      "country",
      "*",
    ],
    "ui:widget": "hidden",
    addressLine1: {
      "ui:widget": "hidden",
    },
    addressLine2: {
      "ui:widget": "hidden",
    },
    addressLine3: {
      "ui:widget": "hidden",
    },
    city: {
      "ui:widget": "hidden",
    },
    postCode: {
      "ui:widget": "hidden",
    },
  },
  country: {
    id: {
      "ui:options": {
        description: t("CLIENT_COUNTRY_DESCRIPTION"),
      },
    },
  },
  region: {
    id: {
      "ui:options": {
        description: t("CLIENT_REGION_DESCRIPTION"),
      },
    },
  },
  name: {
    "ui:widget": "hidden",
  },
  inTesting: {
    "ui:widget": "hidden",
  },
  accountManager: {
    id: {
      "ui:widget": "hidden",
    },
  },
  status: {
    "ui:widget": "hidden",
  },
  reseller: {
    id: {
      "ui:widget": "hidden",
    },
  },
  sector: {
    "ui:options": {
      description: t("CLIENT_SECTOR_DESCRIPTION"),
    },
  },
  industry: {
    id: {
      "ui:options": {
        description: t("CLIENT_INDUSTRY_DESCRIPTION"),
      },
    },
  },
});
